import { CommonModule } from '@angular/common';
import { Component, ChangeDetectionStrategy } from '@angular/core';
import { FieldTypeConfig, FieldType } from '@ngx-formly/core';

@Component({
  selector: "formly-field-template",
  standalone: true,
  templateUrl: "./template.component.html",
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [CommonModule],
})
export class FormlyFieldTemplate extends FieldType<FieldTypeConfig> {

    override defaultOptions = {
      props: {
        template: undefined,
      },
    };

    getTemplateContent(): string {
      const template = this.props.template;
      if (typeof template === 'function') {
        return template(this.model);
      }
      return template;
    }
  
}